<template>
  <b-row>
    <b-col md="4">
      <label>Modalidad de pago*</label>
    </b-col>
    <b-col>
      <b-form-select v-model="value" :options="comboFormasPago" :disabled="disabled" />
    </b-col>
  </b-row>
</template>

<script>
import { mapState } from "pinia";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";
import TipoProyecto from "@/enums/TipoProyecto";

export default {
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useOfertaFormStore, ["oferta", "comboFormasPago"]),
    value: {
      get() {
        if (this.oferta.tipoProyecto == TipoProyecto.SAAS) {
          return this.oferta.formaPagoImplementacionId;
        } else {
          return this.oferta.formaPagoSuscripcionId;
        }
      },
      set(value) {
        if (this.oferta.tipoProyecto == TipoProyecto.SAAS) {
          this.oferta.formaPagoImplementacionId = value;
        } else {
          this.oferta.formaPagoSuscripcionId = value;
        }
      },
    },
  },
};
</script>
